import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import DetailsForm from 'components/forms/DetailsForm';
import FormButtons from 'components/FormButtons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as submissionFormActions from 'actions/submissionFormActions';

class DetailsPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    submitForm: PropTypes.func.isRequired,
    goToPreviousStep: PropTypes.func.isRequired,
    formErrors: ImmutablePropTypes.map.isRequired,
    config: ImmutablePropTypes.map.isRequired,
    categories: PropTypes.array.isRequired,
    saveDraft: PropTypes.func.isRequired,
  };

  submitForm = () => this.form.submit();
  formSubmitted = (data) => this.props.submitForm('details', this.props.history, data);
  saveDraft = () => this.props.saveDraft('details');
  goToPreviousStep = () => this.props.goToPreviousStep('details', this.props.history);

  render() {
    return (
      <div>
        <FormButtons onNext={this.submitForm} onPrevious={this.goToPreviousStep} onSaveDraft={this.saveDraft} />
        <div className="row justify-content-center">
          <div className="col-md-10">
            <Card>
              <DetailsForm
                ref={(ref) => this.form = ref}
                onSubmit={this.formSubmitted}
                formErrors={this.props.formErrors}
                categories={this.props.categories}
                currencies={this.props.currencies}
                config={this.props.config}
              />
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  categories: state.categories,
  currencies: state.currencies,
  config: state.config,
  formErrors: state.submissionForm.getIn(['steps', 'details', 'errors'])
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailsPage);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/SubmissionSteps/DetailsPage.jsx